export const config = {
  backendUrl:
    process.env.REACT_APP_ENVIRONMENT !== "production"
      ? process.env.REACT_APP_BACKEND_URL_DEV
      : process.env.REACT_APP_BACKEND_URL,
  frontendUrl:
    process.env.REACT_APP_ENVIRONMENT !== "production"
      ? process.env.REACT_APP_FRONTEND_URL_DEV
      : process.env.REACT_APP_FRONTEND_URL,
  socketUrl:
    process.env.REACT_APP_ENVIRONMENT !== "production"
      ? process.env.REACT_APP_SOCKET_URL_DEV
      : process.env.REACT_APP_SOCKET_URL,
};
